import { LoadingService } from "./loading.service";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { Auth, User } from "../models/auth.models";
import { BehaviorSubject, Observable, of, throwError } from "rxjs";
import { environment } from "src/environments/environment";
import { switchMap } from "rxjs/operators";
import Swal from "sweetalert2";

@Injectable({ providedIn: "root" })
export class UserProfileService {
  private current_user_sub: BehaviorSubject<User>;
  public current_user: Observable<User>;

  private current_auth_sub: BehaviorSubject<Auth>;
  public current_auth: Observable<Auth>;

  private refreshTokenTimeout;

  constructor(
    private http: HttpClient,
    private loading_service: LoadingService,
    private router: Router,

  ) {
    let local_user = this.check_local_user();
    let local_auth = this.check_local_auth();

    this.current_user_sub = new BehaviorSubject<User>(local_user);
    this.current_user = this.current_user_sub.asObservable();

    this.current_auth_sub = new BehaviorSubject<Auth>(local_auth);
    this.current_auth = this.current_auth_sub.asObservable();
  }

  get_token() {
    return this.current_auth_sub.value.accessToken;
  }

  get_user_role() {
    // console.log('this.current_auth_sub.value :', this.current_auth_sub.value);
    return this.current_auth_sub.value.roles;
  }

  check_admin_user(){
    let roles=  this.current_auth_sub.value.roles;
    return roles.includes("admin");
  }
  check_dealer_user(){
    let roles=  this.current_auth_sub.value.roles;
    return roles.includes("dealer");
  }
  check_staff_user(){
    let roles=  this.current_auth_sub.value.roles;
    return roles.includes("brandTechOperator");
  }
  check_support_user(){
    let roles=  this.current_auth_sub.value.roles;
    return roles.includes("brandSupportOperator");
  }

  check_local_auth() {
    if (!sessionStorage.getItem("auth")) {
      // console.log("local auth data null");
      return null;
    }
    let su = JSON.parse(sessionStorage.getItem("auth"));
    // console.log("auth data from local storage", su);
    return su;
  }

  check_local_user() {
    if (!sessionStorage.getItem("user")) {
      // console.log("local user data null");
      return null;
    }
    let su = JSON.parse(sessionStorage.getItem("user"));
    // console.log("user data from local storage"), su;
    return su;
  }

  signup(user: User) {
    // console.log("Calling auth api service signup");
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    const payload = user;
    payload["appId"] = environment.appId;
    let b = JSON.stringify(payload);
    // console.log(payload);
    return this.http.post<signupResponse>(
      environment.auth_endpoint + "/api/v1/user/account",
      b,
      {
        headers: headers,
      }
    );
  }

  push_auth(auth: Auth) {
    // console.log('auth :', auth);
    sessionStorage.setItem("auth", JSON.stringify(auth));
    this.current_auth_sub.next(auth);
    //this.startRefreshTokenTimer();
  }

  login(email: string, password: string) {
    // console.log("Calling auth api service signup");
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };
    const payload = {
      email: email,
      password: password,
      appId: environment.appId,
    };

    let b = JSON.stringify(payload);
    // console.log(payload);
    return this.http.post<loginResponse>(
      environment.auth_endpoint + "/api/v1/auth/login",
      b,
      {
        headers: headers,
      }
    );
  }

  reset_password(email: string, lang:string) {
    // console.log("Calling auth api service signup");
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };
    const payload = {
      email: email,
      lang: lang,
      appId: environment.appId,
    };

    let b = JSON.stringify(payload);
    // console.log(payload);
    return this.http.post<loginResponse>(
      environment.auth_endpoint + "/api/v1/user/account/reset-password",
      b,
      {
        headers: headers,
      }
    );
  }

  get_user_profile() {

  }

  getAll() {
    return this.http.get<User[]>(`/api/login`);
  }

  old_register(user: User) {
    return this.http.post(`/users/register`, user);
  }

  logout() {
    this.current_auth_sub.next(null);
    this.current_user_sub.next(null);
    sessionStorage.removeItem("auth");
    sessionStorage.removeItem("user");
    return;
  }

  logoutFromDashboard() {
    console.log('logoutFromDashboard');
    this.logout();
    this.router.navigate(["/account/login"]);
  }

  check_response_status(statuscode: any) {
    // console.log('statuscode :', statuscode);
    if (statuscode === 401) {
      this.logoutFromDashboard();
    } else if (statuscode === 403) {
      console.log('in 403');
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "You are not authorized for this operation",
      });
    } else {
      return true;
    }
  }

  startRefreshTokenTimer() {
    // console.log("Refreshing token begin");
    let deadline = this.current_auth_sub.value.expiresIn * 1000 - 60000 * 5; //seconds (3600 mins * 60000) 5 minutes before
    this.refreshTokenTimeout = setTimeout(() => this.refreshToken(), deadline);
  }

  int_refreshToken() {
    //this.loading_service.push_a_loading("tk_refresh");
    Swal.fire({
      position: "bottom-start",
      icon: "warning",
      title: "Refreshing Auth",
      text: "Please wait a couple of seconds, the page will be automatically reloaded",
      toast: true,
      showConfirmButton: true,
      confirmButtonColor: "#3085d6",
      confirmButtonText: "OK",
    });

    // console.log("Calling auth api service refresh token");
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };
    const payload = {
      refreshToken: this.current_auth_sub.value.refreshToken,
      appId: environment.appId,
    };

    let b = JSON.stringify(payload);
    // console.log(payload);
    return this.http.put<loginResponse>(
      environment.auth_endpoint + "/api/v1/auth/login",
      b,
      {
        headers: headers,
      }
    );
    // .subscribe(
    //   (res) => {
    //     this.loading_service.remove_a_loading("tk_refresh");
    //     let new_auth = new Auth();
    //     new_auth = res.data as Auth;
    //     this.push_auth(new_auth);
    //   },
    //   (err) => {
    //     this.loading_service.remove_a_loading("tk_refresh");
    //     this.current_auth_sub.next(null);
    //   }
    // );
  }

  refreshToken() {
    this.loading_service.push_a_loading("tk_refresh");
    // console.log("Calling auth api service refresh token");
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };
    const payload = {
      refreshToken: this.current_auth_sub.value.refreshToken,
      appId: environment.appId,
    };

    let b = JSON.stringify(payload);
    // console.log(payload);
    this.http
      .put<loginResponse>(environment.auth_endpoint + "/api/v1/auth/login", b, {
        headers: headers,
      })
      .subscribe(
        (res) => {
          this.loading_service.remove_a_loading("tk_refresh");
          let new_auth = new Auth();
          new_auth = res.data as Auth;
          this.push_auth(new_auth);
        },
        (err) => {
          this.loading_service.remove_a_loading("tk_refresh");
          this.current_auth_sub.next(null);
        }
      );
  }
}

export interface loginResponse {
  success: boolean;
  data: {
    userId: string;
    accessToken: string;
    refreshToken: string;
    expiresIn: number;
    roles:any;
  };
}
export interface signupResponse {
  success: boolean;
  data: any;
  error?: { message: string; inputValidation: any[] };
}
